/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { Component } from "react";
import { connect } from "react-redux";
// import _ from "lodash";
import containsLongRunningProcess from "components/hoc/containsLongRunningProcess";
import { getTrainingParticipationRules, showModal } from "actions";
import "components/widgets/training/TrainingDetail.css";
import { Trans } from "react-i18next";
// import { Table } from "react-bootstrap";

class TrainingDetailRules extends Component {
  state = { trainingDetailRules: null };

  componentDidMount() {}

  componentDidUpdate = (prevProps, prevState) => {
    if (this.props.timeplanId !== prevProps.timeplanId) {
      this.fetchRules();
    }
  };

  fetchRules = () => {
    this.props.getTrainingParticipationRules(
      this.props.training.training.id,
      this.props.training.isParent,
      this.props.timeplanId,
      this.onBeginRules,
      this.onSuccessRules,
      this.onErrorRules
    );
  };
  onBeginRules = () => {};
  onSuccessRules = (res) => {
    this.props.onProcessEnd();
    this.setState({ trainingDetailRules: res });
  };
  onErrorRules = (e) => {
    this.props.onProcessEnd();
    console.dir(e);
  };

  renderRules = () => {
    if (!this.state.trainingDetailRules) return this.props.spinner;

    return (
      <>
        <div className="trainingDetailGeneralLabel">
          <Trans desc="Hedeflenen Pozisyonlar">10381</Trans>
        </div>
        <ul className="rulesList">
          {this.state.trainingDetailRules.targetPositions?.map((r, index) => {
            return (
              <li key={`${r.name}-${index}`} className="ruleItem">
                {r.name}
              </li>
            );
          })}
        </ul>
        <div>&nbsp;</div>
        <div className="trainingDetailGeneralLabel">
          <Trans desc="Ön Koşullar">10382</Trans>
        </div>
        <ul className="rulesList">
          {this.state.trainingDetailRules.preRequisiteTrainings?.map(
            (r, index) => {
              return (
                <li key={`${r.name}-${index}`} className="ruleItem">
                  {r.name}
                </li>
              );
            }
          )}
        </ul>
      </>
    );
  };

  render() {
    return <div className="trainingRulesContainer">{this.renderRules()}</div>;
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    modal: state.modal,
  };
};

export default connect(mapStateToProps, {
  getTrainingParticipationRules,
  showModal,
})(containsLongRunningProcess(TrainingDetailRules));
